import React from "react";
import { Tag } from "@vitalsource/vstui-icons";
import { connect } from "react-redux";
import { selectors as booksSelectors } from "../../../../redux/books";
import { selectors as brandSelectors } from "../../../../redux/brand";
import { t, Translation } from "../../../core/translate";
import styled from "styled-components";
import PillButton from "../../../components/custom-buttons/pill-button";
import { clampLines } from "../../../components/mixins";
import FlexibleBook from "./flexible-book-card";

const Styled = {
  TitleArea: styled.h3`
    height: 3.8rem;
    ${clampLines(2)}
    font-weight: inherit;
  `,
  GetAccessButtonContainer: styled.div`
    margin-top: 16px;
    display: flex;
    justify-content: center;
  `,
  Badge: styled.div`
    width: 32px;
    height: 32px;
    background: white;
    border-radius: 100%;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
    position: absolute;
    top: 8px;
    inset-inline-end: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  `
};

const ExpiredBook = ({ book, storeUrl, width, skeleton }) => {
  const decodedTitle = book.title.decodeHTML();
  const shouldShowStorePromos =
    storeUrl &&
    book.intendedUses &&
    !!book.intendedUses.find(
      usage => usage === "code-api" || usage === "vst store"
    );
  return (
    <FlexibleBook
      preferredCoverAspectRatio={
        shouldShowStorePromos ? "230 / 212" : "230 / 264"
      }
      book={book}
      skeleton={skeleton}
      width={width}
      remBasedFooterContents={
        <div>
          <Styled.TitleArea>{decodedTitle}</Styled.TitleArea>
          {shouldShowStorePromos && (
            <Styled.GetAccessButtonContainer>
              <PillButton
                outline
                size="small"
                href={`/#/redirect/${encodeURIComponent(storeUrl)}?sso=true`}
                target="_blank"
                aria-label={`${t(
                  "recent-expired.get-access",
                  "Get Access"
                )} - ${decodedTitle}`}
              >
                <Translation id="recent-expired.get-access">
                  Get Access
                </Translation>
              </PillButton>
            </Styled.GetAccessButtonContainer>
          )}
        </div>
      }
      endContent={
        shouldShowStorePromos && (
          <Styled.Badge>
            <Tag />
          </Styled.Badge>
        )
      }
    />
  );
};

const mapStateToProps = (state, props) => ({
  book: booksSelectors.getBookByIsbn(state, props.isbn),
  storeUrl: brandSelectors.getStoreProductRenewalUrl(state, props.isbn, {
    utm_medium: "bookshelf-expired-swimlane"
  })
});

export default connect(mapStateToProps)(ExpiredBook);
